// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { setArchiveDate } from 'church-theme-library/redux/actions/page'

class ArchiveDate extends React.Component {
	handleDateYearChange = ( e ) => {
		const { dispatch } = this.props

		dispatch( setArchiveDate( e.target.value ) )
	}

	handleDateMonthChange = ( e ) => {
		const { dispatch } = this.props

		dispatch( setArchiveDate( false, e.target.value ) )
	}

	render() {
		const { selectedArchive, selectedDateYear, selectedDateMonth } = this.props

		let yearsMarkup,
			yearsOptionsMarkup,
			monthsMarkup,
			monthsOptionsMarkup

		if ( selectedArchive.dates ) {
			yearsOptionsMarkup = Object.keys( selectedArchive.dates ).map( ( key ) => {
				let item = selectedArchive.dates[ key ]

				return (
					<option key={ key } value={ item.n }>{ item.display }</option>
				)
			})
		}

		if ( yearsOptionsMarkup ) {
			yearsMarkup = (
				<div className="form-item form-select">
					<i className="icon-chevron-down" aria-hidden="true"></i>

					<select onChange={ this.handleDateYearChange } value={ selectedDateYear }>
						<option key="all" value="all">All years</option>

						{ yearsOptionsMarkup }
					</select>
				</div>
			)
		}

		if ( selectedArchive.dates && selectedArchive.dates[ `id_${selectedDateYear}` ] ) {
			monthsOptionsMarkup = Object.keys( selectedArchive.dates[ `id_${selectedDateYear}` ].months ).map( ( key ) => {
				let item = selectedArchive.dates[ `id_${selectedDateYear}` ].months[ key ]

				return (
					<option key={ key } value={ item.n }>{ item.display }</option>
				)
			})
		}

		// Show if there are years:
		if ( yearsOptionsMarkup ) {
			monthsMarkup = (
				<div className="form-item form-select">
					<i className="icon-chevron-down" aria-hidden="true"></i>

					<select onChange={ this.handleDateMonthChange } value={ selectedDateMonth }>
						<option key="all" value="all">All months</option>

						{ monthsOptionsMarkup }
					</select>
				</div>
			)
		}

		if ( ! yearsMarkup ) {
			return null
		}

		return (
			<div className="archive-date">
				<div className="-inner">
					{ yearsMarkup }
					{ monthsMarkup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		selectedArchive: state.page.selectedArchive,
		selectedDateYear: state.page.selectedDateYear,
		selectedDateMonth: state.page.selectedDateMonth,
	}
}

export default connect( mapStateToProps )( ArchiveDate )
